import { ComponentSettings } from "../settings/settings";

const settings = {
  permission: {},
  list: {},
  url: {
    releaseNotesUrl: "",
  },
  text: {
    version: {
      de: "Version: ",
      en: "Version: ",
      nl: "Versie: ",
    },
    support: {
      de: "Benötigen Sie Unterstützung?",
      en: "Need Support?",
      nl: "Hulp Nodig?",
    },
    contact: {
      de: "Bei Fragen oder Problemen wenden Sie sich bitte an unser Team unter <b><i>support@am-sys.com</i></b> oder <b><i>+49 (0) 4103 92 853 60</i></b>",
      en: "If you have questions or need assistance, please contact our team at <b><i>support@am-sys.com</i></b> or <b><i>+49 (0) 4103 92 853 60</i></b>",
      nl: "Als u vragen heeft of hulp nodig heeft, neem contact op met ons team op <b><i>support@am-sys.com</i></b> of <b><i>+49 (0) 4103 92 853 60</i></b>",
    },
    bannerTitle: {
      de: "Softwareaktualisierung v",
      en: "Software update v",
      nl: "Software-update v",
    },
    bannerMessage: {
      de: "Entdecke die Neuerungen in diesem Update",
      en: "Discover what’s new in this update",
      nl: "Ontdek wat er nieuw is in deze update",
    },
    view: {
      de: "Ansehen",
      en: "View",
      nl: "Bekijken",
    },
  },
  field: {},
  additionalInfo: {},
};
export const releaseNotesModal: ComponentSettings<typeof settings> = settings;
